import React from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { toastErrorMessage } from "../../utils/helper/myToast";
import { Image } from "./Image";
import Button from "./Button";

interface Props {
  handleSignIn: (data: any) => Promise<void>;
  btnText: string;
  isLoading: boolean;
  hideOneTab?: boolean;
  prefillEmail?: string;
}

const GoogleSignInButton: React.FC<Props> = ({ handleSignIn, btnText, isLoading, hideOneTab = false, prefillEmail }) => {
  const login = useGoogleLogin({
    onSuccess: (tokenResponse: any) => handleSignIn(tokenResponse),
    onError: (e: any) => {
      console.error("Login failed", e);
      toastErrorMessage(`Failed to ${hideOneTab ? "authorized" : "log in"}. Please try again.`);
    },
    flow: "auth-code",
    ux_mode: "popup",
    hint: prefillEmail,
  });

  return (
    <>
      <div className="hidden">
        {!hideOneTab && (
          <GoogleLogin
            onSuccess={(credentialResponse: any) => {
              console.log(credentialResponse);
              handleSignIn(credentialResponse);
            }}
            onError={() => {
              console.log("Login Failed");
              toastErrorMessage("Login Failed");
            }}
            useOneTap
          />
        )}
      </div>
      <Button variant="primary" size="small" isFullWidth isLoading={isLoading} opacityLoader className=" shadow-button !bg-white !text-black" onClick={login}>
        <div className=" flex items-center gap-2">
          <Image src="/icons/google-icon.png" alt="Google icon" className="" width="16" height="16" />
          <span className="text-13 leading-5">{btnText}</span>
        </div>
      </Button>
    </>
  );
};

export default GoogleSignInButton;
